<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2021-04-27 14:54:07
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/zui.png" /></div>
      <p>zui</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zui-patches";
const versions = [
  '2.6.4',
  '2.6.1',
  '2.6.0',
  '2.6.0-1',
  '2.3.9'
]
export default {
  name: "index",
  data() {
    return {
      fileList: versions.map(v => ({
        label: v,
        linkList: [
          `${ur}/${v}/lib/index.js`,
          `${ur}/${v}/lib/theme-chalk/index.css`
        ]
      }))
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZuiPatches.vue